import styles from './MetropoleOnlyHeader.module.css'

import { SvgOfficialLogoMetropole } from '../../../svg/SvgComponents'

const MetropoleOnlyHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <SvgOfficialLogoMetropole />
      </div>
    </header>
  </>
)

export default MetropoleOnlyHeader

